import { AnimatePresence } from 'framer-motion';
import { Box } from '@/ui';
import { printVisibility } from '../../lib/printStyles';
import { getStyleById, type SceneStyle } from '../../lib/theme';
import type { BackgroundProps } from './Background';

export const SceneBackground = ({ themeId }: BackgroundProps) => {
  const sceneStyle = getStyleById(themeId ?? '');
  const scene = sceneStyle as SceneStyle | undefined;

  let background = scene?.gradient ?? 'white';

  // use colors array to create a gradient if available
  if (scene?.colors && scene.colors.length >= 2) {
    background = `linear-gradient(${scene.direction ?? 180}deg, ${scene.colors[0]} 0%, ${scene.colors[1]} 100%), #FFF`;
  }

  return (
    <Box
      inset="0"
      pointerEvents="none"
      pos="fixed"
      sx={printVisibility.hide()}
      zIndex={-1}
      style={{
        background: background,
      }}
    >
      {scene?.backgroundImageId && (
        <AnimatePresence>
          <img
            alt={scene?.name}
            key={scene?.backgroundImageId}
            src={`/styles/backgrounds/${scene?.backgroundImageId}.svg`}
            style={{
              position: 'absolute',
              top: `${scene.backgroundPosition?.[0] ?? 0}px`,
              left: `${scene.backgroundPosition?.[1] ?? 0}px`,
              width: '100%',
              pointerEvents: 'none',
              zIndex: -1,
            }}
          />
        </AnimatePresence>
      )}
      {scene?.sparkleId && (
        <AnimatePresence>
          <img
            alt={scene?.name}
            key={scene?.sparkleId}
            src={`/styles/sparkles/${scene?.sparkleId}.svg`}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              pointerEvents: 'none',
              zIndex: -1,
            }}
          />
        </AnimatePresence>
      )}
      {scene?.patternId && (
        <AnimatePresence>
          <Box
            inset="0"
            pointerEvents="none"
            pos="fixed"
            zIndex={-1}
            style={{
              backgroundImage:
                scene?.patternId !== 'none'
                  ? `url(/styles/patterns/${scene?.patternId})`
                  : undefined,
              backgroundRepeat:
                scene?.patternId !== 'none' ? 'repeat' : undefined,
              backgroundSize: scene?.patternSize ?? '300px',
              color: scene?.patternColor ?? 'rgba(255, 255, 255, 1)',
            }}
          />
        </AnimatePresence>
      )}
    </Box>
  );
};
